module.exports = __webpack_public_path__ + "img/wx-footer.c761cbae.jpg";